import React, { Component, PureComponent } from 'react';
import { Select, Icon } from '@tencent/spaui';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { formatAgencyList } from '@/pages/agency/utils/format';
import { getPageConfig } from '@/pages/agency/utils/util';
import { AD_PLATFORM_TYPE_NAME, AD_PLATFORM_TYPE_RULE, AGENCY_UID_COOKIE_NAME } from '@/constants/Constants';
import cookie from '@/utils/cookie.js';
import classnames from 'classnames';
import EventBus from 'eventing-bus';
import globalStore from '@/stores';
import { isObservableArray } from 'mobx';
import commonReport from '@/common/common-report';
import { hasFeatureFlag } from '@/services';
import { OperatorType } from '@/model/user';
import { CustomerStatus } from '@/model/agency';
import message from '@/utils/message';

import './assets/less/index.scoped.less';

const MAX_LIMIT = 450;

export function processAgencyList({ agency_list, filterFeatureFlag = null, platform = AD_PLATFORM_TYPE_NAME.default, onlyValid = false, filter = null, extra = {}, isDefaultExpand = true, childAgencyEnable = true, isMergeMp = false }) {
  let formattedAgencyList = formatAgencyList(agency_list).map((item) => {
    return {
      ...item,
      extra: extra[item.agency_uid],
    };
  });
  // 过滤非有效服务商
  if (onlyValid) {
    formattedAgencyList = formattedAgencyList.filter((v) => v.customer_status === CustomerStatus.normal);
  }
  if (filterFeatureFlag) {
    formattedAgencyList = formattedAgencyList.filter((v) => hasFeatureFlag(filterFeatureFlag, v.agency_uid));
  } else if (filter) {
    formattedAgencyList = formattedAgencyList.filter(filter);
  } else if (platform) {
    // 页面支持多个平台
    if (isObservableArray(platform) || Array.isArray(platform)) {
      // 多个平台过滤的并集
      formattedAgencyList = formattedAgencyList.filter((v) => {
        return _.reduce(
          platform.slice(),
          (result, p) => {
            result = result || AD_PLATFORM_TYPE_RULE[p](v, { isMergeMp });
            return result;
          },
          false,
        );
      });
    } else {
      formattedAgencyList = formattedAgencyList.filter((v) => AD_PLATFORM_TYPE_RULE[platform](v, { isMergeMp }));
    }
  }

  const childAgencyListMap = formattedAgencyList.reduce((prev, curr) => {
    if (curr.parent_agency_uid) {
      curr.extra = extra[curr.agency_uid];
      if (prev[curr.parent_agency_uid]) {
        prev[curr.parent_agency_uid].push(curr);
      } else {
        prev[curr.parent_agency_uid] = [curr];
      }
    }
    return {
      ...prev,
    };
  }, {});

  let parentFormattedAgencyList = formattedAgencyList.map((item) => {
    // 非独立的二代需要隐藏

    let isHide = false;

    if (item.parent_agency_uid) {
      const index = _.findIndex(formattedAgencyList, (itemY) => itemY.agency_uid === item.parent_agency_uid);
      isHide = index !== -1;
    }
    return {
      ...item,
      hide: isHide,
      isExpand: isDefaultExpand,
      data: childAgencyListMap[item.value] || [],
    };
  });

  // 不展示二代
  if (!childAgencyEnable) {
    parentFormattedAgencyList = parentFormattedAgencyList
      .filter((item) => !item.parent_agency_uid)
      .map((item) => {
        delete item.data;
        return item;
      });
  }
  return parentFormattedAgencyList;
}

/**
 * @description 对象中多个字段是否和指定字符串匹配
 * @param searchValue
 * @param data
 * @param searchFields
 */
export function isExistInFields(searchValue = '', data = {}, searchFields = []) {
  for (const field of searchFields) {
    if (String(data[field])?.indexOf(searchValue) !== -1) {
      return true;
    }
  }

  return false;
}

export class ValueAreaComponent extends PureComponent {
  renderValue = () => {
    const { value, data, placeholder, multiple, checkAll, checkAllLabel, checkAllIsChecked } = this.props;
    if (multiple && checkAll && _.isArray(value) && checkAllIsChecked) {
      return checkAllLabel;
    }
    if (!value) {
      return placeholder || '请选择';
    }
    if (value && _.isArray(value) && value.length === 0) {
      return placeholder || '请选择';
    }
    if (value && _.isArray(value)) {
      return value.map((v) => data[v].label).join('，');
    }
    return data[value].label;
  }

  render() {
    const { value, multiple, onOpen, useDefaultDropdownArrow, clear, onChange } = this.props;

    const hasSelected = multiple ? value?.length : value;
    return (
      <a onClick={onOpen} className={`selection-single ${hasSelected ? '' : 'placeholder'}`} data-report-global="switch-agency">
        <span className="selection-single-text">{this.renderValue()}</span>
        {clear && hasSelected ? <div className="spaui-select-clear" role="button" onClick={(e) => {
          e.stopPropagation();
          onChange(e, multiple ? [] : null);
          onOpen(e, false);
        }}>
          <svg viewBox="0 0 16 16" width="16px" height="16px">
            <circle fill="currentColor" fillRule="evenodd" cx="8" cy="8" r="8"></circle>
            <path d="M5.333 5.333l5.334 5.334M10.667 5.333l-5.334 5.334" stroke="#FFF" strokeLinecap="square"></path>
          </svg>
        </div> : null}
        {
          useDefaultDropdownArrow ? <Icon name="dropdown-arrow-outlined" className="dropdown-arrow" /> : <i className="nav-caret" />
        }
      </a>
    );
  }
}

export class SelectionDataComponent extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      ...this.getMdmList(props.data),
    };

    this.isClickExpanding = false;
    this.isClickChild = false;
  }

  componentWillReceiveProps(nextProps) {
    if (!_.isEqual(nextProps.data, this.props.data)) {
      this.setState({
        ...this.getMdmList(nextProps.data),
      });
    }
  }

  getMdmList = (_data) => {
    const data = _data.filter((v) => !v.hide);
    const mdm_group = _.groupBy(data, 'mdm_id');
    const mdm_list = _.keys(mdm_group)
      .map((v) => {
        const mdm_id = Number(v);
        const list = mdm_group[v];
        return {
          mdm_id,
          mdm_name: _.get(list, '0.mdm_name') || `MDMID:${mdm_id}`,
          data: list,
          isExpand: true,
        };
      });
    return {
      data,
      mdm_list,
    };
  }

  handleExpand = (e, selectedItem) => {
    this.isClickExpanding = true;
    this.setState(
      (prevState) => {
        const newData = prevState.data?.map((v) => {
          if (v.agency_uid === selectedItem.agency_uid) {
            return {
              ...v,
              isExpand: !v.isExpand,
            };
          }
          return v;
        });
        return {
          ...prevState,
          data: newData,
        };
      },
      () => (this.isClickExpanding = false),
    );
  }

  handleMdmExpand = (e, selectedItem) => {
    this.isClickExpanding = true;
    this.setState(
      (prevState) => {
        const newData = prevState.mdm_list.map((v) => {
          if (v.mdm_id === selectedItem.mdm_id) {
            return {
              ...v,
              isExpand: !v.isExpand,
            };
          }
          return v;
        });
        return {
          ...prevState,
          mdm_list: newData,
        };
      },
      () => (this.isClickExpanding = false),
    );
  }

  handleChange = (e, value, type) => {
    if (this.isClickExpanding) {
      return;
    }
    this.isClickChild = true;
    this.props?.onChange(e, value);
    setTimeout(() => {
      this.isClickChild = false;
    });
  }

  handleMdmClick = (e, mdm) => {
    if (this.isClickExpanding || this.isClickChild) {
      return;
    }
    const { value, onChange } = this.props;
    const mdmAgencyUidList = this.getAgencyListByMdm(mdm);
    const others = _.difference(value, mdmAgencyUidList);
    const newValue = this.isMdmChecked(mdm) ? others : [...others, ...mdmAgencyUidList];
    onChange?.(e, newValue, {});
  }

  isChecked = (current) => {
    const { multiple, value } = this.props;
    if (multiple && _.isArray(value)) {
      return value.indexOf(current.value) !== -1;
    }
    return value === current.value;
  };

  isMdmChecked = (mdm) => {
    const { multiple, value } = this.props;
    const mdmAgencyUidList = this.getAgencyListByMdm(mdm);
    if (multiple && _.isArray(value) && mdmAgencyUidList.length) {
      return _.difference(mdmAgencyUidList, value).length === 0;
    }
    return false;
  }

  getAgencyListByMdm = (mdm) => {
    return _.uniq(mdm?.data?.map((parent) => {
      const children = _.map(parent.data, 'agency_uid', []);
      return [parent.agency_uid, ...children];
    }).flat() || []);
  }

  render() {
    const { multiple, checkAll, checkAllLabel, checkAllIsChecked, onCheckAllChange, searchValue, searchFields, value, extra, unClose } = this.props;
    let { data, mdm_list } = this.state;
    const { bm_name } = globalStore.account;

    if (searchValue) {
      data = _.compact(data?.map((item) => {
        if (isExistInFields(searchValue, item, searchFields)) {
          return { ...item, isSearchMatched: true };
        }
        const matchedChildList = (item.data || [])
          .filter((child) => isExistInFields(searchValue, child, searchFields))
          .map((item) => ({
            ...item,
            isSearchMatched: true,
          }));

        if (matchedChildList.length) {
          return {
            ...item,
            isExpand: true,
            data: matchedChildList,
          };
        }
        return null;
      }));
    }

    // 公司帐号
    const mdm_group = _.groupBy(data, 'mdm_id');
    mdm_list = mdm_list.map((v) => {
      const list = mdm_group[String(v.mdm_id)];
      return {
        ...v,
        data: list,
      };
    });

    return (
      <ul className={classnames('selection-data-component', { multiple })}>
        {/* 集团，全选 */}
        <li
          onClick={checkAll ? onCheckAllChange : _.noop}
          className={classnames('select-item bm-item', {
            'is-select': checkAllIsChecked,
            checked: checkAllIsChecked,
          })}
          data-report-global="switch-agency-checkall"
        >
          <div className={classnames('bm-item-content', { 'clickable': checkAll })}>
            {checkAll && checkAllIsChecked ? (
              <span className="icon-checkmark">
                <Icon name="check-bold-outlined" />
              </span>
            ) : null}
            <i className="spaui-icon icon-bm" />
            <span className="name">{bm_name}</span>
          </div>
        </li>
        {/* 公司 */}
        {mdm_list.map((mdm) => {
          return (
            <li
              onClick={multiple ? (e) => this.handleMdmClick(e, mdm) : _.noop}
              className={classnames('select-item mdm-item', {
              })}
              key={mdm.mdm_id}
            >
              <div className={classnames('mdm-item-content', { clickable: multiple })}>
                {multiple && this.isMdmChecked(mdm) ? (
                  <span className="icon-checkmark">
                    <Icon name="check-bold-outlined" />
                  </span>
                ) : null}
                <i className="spaui-icon icon-mdm" />
                <span className="name">{mdm.mdm_name}</span>
                <div
                  className={classnames('icon-expand', { 'is-expand': mdm.isExpand })}
                  onClick={(e) => {
                    this.handleMdmExpand(e, mdm);
                  }}
                  data-report-global="switch-agency-expand-mdm"
                >
                  <Icon name="dropdown-arrow-outlined" />
                </div>
              </div>
              {mdm.isExpand ? (
                <ul>
                  {mdm.data?.map((parent) => {
                    const isParent = !parent.parent_agency_uid;
                    return (
                      <li
                        onClick={(e) => this.handleChange(e, parent.value || parent)}
                        className={classnames('select-item', {
                          'parent-item': isParent,
                          'child-item': !isParent,
                          'is-select': this.isChecked(parent),
                          unread: extra?.[parent?.value]?.unread,
                          checked: this.isChecked(parent),
                          'is-search-matched': parent.isSearchMatched,
                        })}
                        key={parent.value}
                        data-report-global="switch-agency-selected"
                      >
                        <div className={classnames({
                          'parent-item-content clickable': isParent,
                          'child-item-content clickable': !isParent,
                        })}>
                          {this.isChecked(parent) ? (
                            <span className="icon-checkmark">
                              <Icon name="check-bold-outlined" />
                            </span>
                          ) : null}
                          <i className={classnames('spaui-icon', {
                            'icon-agency': isParent,
                            'icon-child-agency': !isParent,
                          })} />
                          <span className="name">{parent.label}</span>
                          {parent?.data?.length ? (
                            <div
                              className={classnames('icon-expand', { 'is-expand': parent.isExpand })}
                              onClick={(e) => {
                                this.handleExpand(e, parent);
                              }}
                              data-report-global="switch-agency-expand-parent"
                            >
                              <Icon name="dropdown-arrow-outlined" />
                            </div>
                          ) : null}
                        </div>

                        {parent.isExpand ? (
                          <ul>
                            {parent?.data?.map((child) => {
                              return (
                                <li
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    unClose();
                                    this.handleChange(e, child.value || child, 'child');
                                  }}
                                  className={classnames('select-item child-item', {
                                    'is-select': this.isChecked(child),
                                    unread: extra?.[child?.value]?.unread,
                                    checked: this.isChecked(child),
                                    'is-search-matched': child.isSearchMatched,
                                  })}
                                  key={child.value}
                                  data-report-global="switch-agency-selected"
                                >
                                  <div className="child-item-content clickable">
                                    {this.isChecked(child) ? (
                                      <span className="icon-checkmark">
                                        <Icon name="check-bold-outlined" />
                                      </span>
                                    ) : null}
                                    <i className="spaui-icon icon-child-agency" />
                                    <span className="name">{child.label}</span>
                                  </div>
                                </li>
                              );
                            })}
                          </ul>
                        ) : null}
                      </li>
                    );
                  })}
                </ul>
              ) : null}
            </li>
          );
        })
        }
      </ul>
    );
  }
}

// 发布订阅机制监听事件
export const ACCOUNT_SELECT_CHANGE_LISTENER = 'ACCOUNT_SELECT_CHANGE_LISTENER';

class AccountSelect extends Component {
  constructor(props, context) {
    super(props, context);

    this.unsubscription = EventBus.on(ACCOUNT_SELECT_CHANGE_LISTENER, (value) => {
      if (this.props.isGlobalUse) {
        this.changeListener(value);
      }
    });
    if (props.isDefaultValue) {
      this.state = {
        value: props.defaultValue || (props.multiple ? [AccountSelect.getAgencyUid(props)] : AccountSelect.getAgencyUid(props)),
      };
    } else {
      this.state = {
        value: null,
      };
    }
  }

  componentDidMount() {
    const { multiple, checkAll, isDefaultCheckAll, isGlobalUse } = this.props;
    // 多选不设置cookie
    if (!multiple && isGlobalUse) {
      this.setCookie(AccountSelect.getAgencyUid());
    }
    // 默认全选
    if (multiple && checkAll && isDefaultCheckAll) {
      this.setState({
        value: AccountSelect.getAgencyList(this.props).map((v) => v.value || v),
      });
    }
  }

  componentWillUnmount() {
    if (typeof this.unsubscription === 'function') {
      this.unsubscription();
    }
  }

  /**
   * 静态方法获取服务商id
   * @param platform
   * @param filter
   * @param childAgencyEnable
   */
  static getAgencyUid = (props = {}) => {
    const { platform, filterFeatureFlag, filter, childAgencyEnable = true, isMergeMp, onlyValid, withTechAgency = false } = props;
    const { agency_list, all_agency_list } = globalStore.account;
    const _platform = platform || getPageConfig().platform || AD_PLATFORM_TYPE_NAME.default;
    const data = processAgencyList({
      agency_list: withTechAgency ? all_agency_list : agency_list,
      platform: _platform,
      filterFeatureFlag,
      filter,
      childAgencyEnable,
      isMergeMp,
      onlyValid,
    });
    const valueFromList = Number(data[0]?.agency_uid);
    const valueFromCookie = Number(cookie.get(AGENCY_UID_COOKIE_NAME[isObservableArray(_platform) ? AD_PLATFORM_TYPE_NAME.default : _platform]));
    // 如果cookie在列表没找到，则返回第一个
    if (!_.find(data, (v) => v.agency_uid === valueFromCookie)) {
      return valueFromList;
    }
    // 如果不允许二代，则返回第一个
    // if (!childAgencyEnable) {
    //   return valueFromList;
    // }

    // 优先返回cookie
    return valueFromCookie || valueFromList;
  }

  /**
   * 静态方法获取服务商
   * @param props
   */
  static getAgency = (props = {}) => {
    const { agency_list } = globalStore.account;
    const agency_uid = AccountSelect.getAgencyUid(props);
    const agency = _.find(agency_list, (v) => v.agency_uid === agency_uid) || {};
    return agency;
  }

  /**
   * 静态方法获取服务商列表
   * @param props
   */
  static getAgencyList = (props = {}) => {
    const { platform, filterFeatureFlag, filter, childAgencyEnable = true, isMergeMp, onlyValid, isLimitAccount = false, limitAccount, withTechAgency = false } = props;
    const { agency_list, all_agency_list, operator_type } = globalStore.account;
    const _platform = platform || getPageConfig().platform || AD_PLATFORM_TYPE_NAME.default;
    const data = processAgencyList({
      agency_list: withTechAgency ? all_agency_list : agency_list,
      platform: _platform,
      filterFeatureFlag,
      filter,
      childAgencyEnable,
      isMergeMp,
      onlyValid,
    });
    // 是否限制数量
    if (isLimitAccount || limitAccount) {
      if (data.length <= (limitAccount || MAX_LIMIT)) {
        return data;
      }
      // 超过数量限制时，根据一二代过滤服务商
      if (operator_type === OperatorType.sub) {
        return data.filter((v) => v.parent_agency_uid);
      }
      return data.filter((v) => !v.parent_agency_uid);
    }
    return data;
  }

  /**
   * 静态方法获取服务商id-信息映射
   * @param props
   */
  static getAgencyMap = (props = {}) => {
    const agencyList = AccountSelect.getAgencyList(props);
    const map = agencyList.reduce((map, v) => ({ ...map, [v.agency_uid]: v }), {});
    return map;
  }

  changeListener = (value) => {
    if (this.props.multiple) {
      // 暂不支持多选时的监听，后续如果需要可以继续添加逻辑
      return;
    }
    const targetAgency = _.find(globalStore.account.agency_list, (item) => item.agency_uid == +value) || {};
    this.onChange(null, value, { [value]: targetAgency });
  }

  /**
   * 设置服务商id的cookie
   * @param value
   */
  setCookie = (value) => {
    const { platform = AD_PLATFORM_TYPE_NAME.default } = getPageConfig();
    cookie.set(AGENCY_UID_COOKIE_NAME.default, value, null, '/', 72);
    commonReport.setCommonInfo({ agency_uid: value });
    if (!isObservableArray(platform)) {
      cookie.set(AGENCY_UID_COOKIE_NAME[platform], value, null, '/', 72);
    }
  }

  onChange = (e, value, valueMap) => {
    const { isLimitAccount, limitAccount } = this.props;
    if (!this.props.multiple && this.props.isGlobalUse) {
      this.setCookie(value);
    }
    if (this.props.multiple && _.isArray(value) && (isLimitAccount || limitAccount)) {
      const limit = limitAccount || MAX_LIMIT;
      if (value.length > limit) {
        message.strongwarn(`最多选择${limit}个服务商，请重新选择`);
        return;
      }
    }
    this.setState({
      value,
    });
    if (this.props.onChange) {
      this.props.onChange(e, value, valueMap);
    }
  }

  render() {
    const { agency_list, all_agency_list } = globalStore.account;
    const { platform } = getPageConfig();
    const { filterFeatureFlag, filter, extra = {}, isLabel = true, label = '所属服务商', isDefaultExpand = true, childAgencyEnable, isGlobalUse, withTechAgency } = this.props;
    const { onChange, className, isMergeMp, onlyValid, ...otherProps } = this.props;
    const { value } = this.state;

    const data = processAgencyList({
      agency_list: withTechAgency ? all_agency_list : agency_list,
      platform: this.props.platform || platform,
      filterFeatureFlag,
      filter,
      extra,
      isDefaultExpand,
      childAgencyEnable,
      isGlobalUse,
      isMergeMp,
      onlyValid,
    });

    return (
      <div className={classnames('agency-select account-select', className)} id={isGlobalUse ? 'global-account-select' : null}>
        {isLabel ? label : null}
        <Select value={value} placementAlign={'right'} {...otherProps} searchFields={['label', 'value']} onChange={this.onChange} search={data.length > 5} extra={extra} ValueAreaComponent={ValueAreaComponent} SelectionDataComponent={SelectionDataComponent} data={data} />
      </div>
    );
  }
}

AccountSelect.propTypes = {
  ...Select.propTypes,
  onChange: PropTypes.func,
  // 平台
  platform: PropTypes.string,
  // 过滤规则的灰度开关，优先级高于filter
  filterFeatureFlag: PropTypes.string,
  // 是否只展示有效服务商
  onlyValid: PropTypes.bool,
  // 自定义过滤规则
  filter: PropTypes.func,
  // 每一项的附加信息
  extra: PropTypes.object,
  // 是否默认展开
  isDefaultExpand: PropTypes.bool,
  // 是否展示二代
  childAgencyEnable: PropTypes.bool,
  // 是否多选
  multiple: PropTypes.bool,
  // 是否展示全选按钮
  checkAll: PropTypes.bool,
  // 全选提示文案
  checkAllLabel: PropTypes.string,
  // 是否默认全选
  isDefaultCheckAll: PropTypes.bool,
  // 是否全局生效
  isGlobalUse: PropTypes.bool,
  // 默认值
  defaultValue: PropTypes.oneOfType([PropTypes.number, PropTypes.array]),
  // 是否需要默认值
  isDefaultValue: PropTypes.bool,
  // 使用默认下拉箭头
  useDefaultDropdownArrow: PropTypes.bool,
  // 是否mp融合
  isMergeMp: PropTypes.bool,
  // 是否限制账户数量
  isLimitAccount: PropTypes.bool,
  // 限制账户数量，默认MAX_LIMIT
  limitAccount: PropTypes.number,
  // 是否包含技术服务商
  withTechAgency: PropTypes.bool,
};

AccountSelect.defaultProps = {
  childAgencyEnable: true,
  multiple: false,
  checkAll: false,
  checkAllLabel: '全部帐号',
  isDefaultCheckAll: true,
  isGlobalUse: true,
  isDefaultValue: true,
  useDefaultDropdownArrow: false,
  isMergeMp: false,
  isLimitAccount: false,
  limitAccount: 0,
  onlyValid: false,
  withTechAgency: false,
};

export default AccountSelect;
